import React from "react";
import { CallbackComponent } from "redux-oidc";
import userManager from "../userManager";

class CallbackPage extends React.Component {
  render() {
    // just redirect to '/' in both cases
    return (
      <CallbackComponent
        userManager={userManager}
        successCallback={() => {
          console.log('callback');
          this.props.history.push("/")
        }}
        errorCallback={error => {
          //this.props.history.push("/");
          userManager.signinRedirect();
          console.error(error);
        }}
      >
        <div>Redirecting...</div>
      </CallbackComponent>
    );
  }
}

export default CallbackPage;